"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageExpandableRow = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var react_use_1 = require("react-use");
var styled_components_1 = __importDefault(require("styled-components"));
var definitions_1 = require("../../../hooks/definitions");
var coverage_display_1 = require("../../coverage-display");
function CoverageExpandableRow(_a) {
    var _this = this;
    var identifier = _a.identifier, lineOfCoverageDetails = _a.lineOfCoverageDetails, onSetIsModalOpen = _a.onSetIsModalOpen, _b = _a.isDeletable, isDeletable = _b === void 0 ? false : _b, onDelete = _a.onDelete, _c = _a.isUpdating, isUpdating = _c === void 0 ? false : _c, _d = _a.isEditable, isEditable = _d === void 0 ? false : _d;
    var renderLineOfCoverageType = definitions_1.useDefinitionsHelpers().renderLineOfCoverageType;
    var _e = react_use_1.useToggle(false), isDeleting = _e[0], setIsDeleting = _e[1];
    var title = lineOfCoverageDetails.displayName
        ? renderLineOfCoverageType(lineOfCoverageDetails.type) + " - " + lineOfCoverageDetails.displayName
        : renderLineOfCoverageType(lineOfCoverageDetails.type);
    var handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (onDelete) {
                onDelete(identifier);
            }
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_ui_1.ExpandableRow, { key: "expandable-row-" + identifier, expanded: false },
            react_1.default.createElement(core_ui_1.ExpandableHead, { isClickAnywhere: true, alignItems: "center" },
                react_1.default.createElement(core_ui_1.Text, { weight: 600 }, title),
                react_1.default.createElement(IconEditWrapper, { onClick: function (e) {
                        e.stopPropagation();
                    } },
                    react_1.default.createElement(core_ui_1.Stack, { gap: 4, direction: "horizontal" },
                        isEditable && react_1.default.createElement(core_ui_1.IconButton, { type: "edit", onClick: onSetIsModalOpen, disabled: isUpdating }),
                        isDeletable && onDelete && react_1.default.createElement(core_ui_1.IconButton, { type: "remove", onClick: setIsDeleting, disabled: isUpdating })))),
            react_1.default.createElement(core_ui_1.ExpandableBody, null,
                react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(core_ui_1.CircleSpinner, { label: "Loading coverage details..." }) },
                    react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { fallback: react_1.default.createElement(core_ui_1.Alert, null, "There was a problem loading the coverage details.") },
                        react_1.default.createElement(core_ui_1.Spacing, { height: 16 }),
                        react_1.default.createElement(coverage_display_1.CoverageDisplay, { lineOfCoverage: lineOfCoverageDetails }))))),
        isDeletable && onDelete && (react_1.default.createElement(core_ui_1.ActionModal, { variant: "dangerous", confirmText: "Yes, delete coverage", isOpen: isDeleting, onClose: setIsDeleting, onConfirm: handleDelete, title: "Are you sure you want to delete this line of coverage?", cancelText: "Cancel" }, "You will not be able to recover these coverage details."))));
}
exports.CoverageExpandableRow = CoverageExpandableRow;
var IconEditWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 58px;\n  top: 50%;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  right: 58px;\n  top: 50%;\n  transform: translateY(-50%);\n"])));
var templateObject_1;
